import React, { useCallback } from "react";
import { PlateElement, type PlateElementProps, useEditorRef } from "platejs/react";
import type { ChecklistBlockElement, ChecklistItem } from "../schema";

export function ChecklistBlock(props: PlateElementProps) {
  const el = props.element as ChecklistBlockElement;
  const editor = useEditorRef();

  const toggle = useCallback(
    (itemId: string) => {
      const items: ChecklistItem[] = el.items.map((i) =>
        i.id === itemId ? { ...i, done: !i.done } : i,
      );
      editor.tf.setNodes({ items } as Partial<ChecklistBlockElement>, { at: props.path });
    },
    [editor, props.path, el.items],
  );

  const pendientes = el.items.filter((i) => !i.done).length;

  return (
    <PlateElement {...props} style={{ margin: "16px 0" }}>
      <div
        contentEditable={false}
        style={{
          border:
            pendientes === 0 ? "1px solid rgba(34,197,94,0.5)" : "2px dashed rgba(239,68,68,0.4)",
          borderRadius: 8,
          background: pendientes === 0 ? "rgba(34,197,94,0.06)" : "rgba(239,68,68,0.04)",
          padding: 12,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
          <i
            className={pendientes === 0 ? "bx bx-check-shield" : "bx bx-shield-x"}
            style={{
              color: pendientes === 0 ? "#22c55e" : "#ef4444",
              fontSize: "1.1rem",
            }}
          />
          <strong style={{ color: "#fff", fontSize: "0.9rem", flex: 1 }}>
            Checklist de cierre
          </strong>
          <span style={{ fontSize: "0.7rem", color: "#888" }}>
            {pendientes === 0 ? "Listo" : `${pendientes} pendiente(s)`}
          </span>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          {el.items.map((i) => (
            <label
              key={i.id}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                cursor: "pointer",
                fontSize: "0.85rem",
                color: i.done ? "#888" : "#ddd",
                textDecoration: i.done ? "line-through" : "none",
              }}
            >
              <input type="checkbox" checked={i.done} onChange={() => toggle(i.id)} />
              {i.label}
            </label>
          ))}
        </div>
      </div>
      {props.children}
    </PlateElement>
  );
}
